export const LISTENING_GLOW_HTML = `<!doctype html>
<html><head>
<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1">
<meta http-equiv="Content-Security-Policy" content="default-src 'none'; script-src 'unsafe-inline'; style-src 'unsafe-inline'; img-src data:">
<style>
html,body{margin:0;width:100%;height:100%;overflow:hidden;background:transparent;pointer-events:none}
#living-glow{position:absolute;inset:0;width:100%;height:100%}
#dacr-button{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:180px;height:180px;border-radius:50%;color:#2a2b2c}
.dacr-button-visual{position:relative;width:100%;height:100%;border-radius:inherit;display:grid;place-items:center;isolation:isolate;pointer-events:none;background:linear-gradient(145deg,rgba(255,255,255,.84),rgba(255,255,255,.68) 48%,rgba(255,255,255,.76));box-shadow:0 8px 26px #0000001a,0 0 .3px .3px #dbdbdb,0 2px 5px #252c3710,inset 0 1.5px 1.5px #ffffffed,inset 0 -1.5px 2px #8993a426}
.dacr-button-visual::before{content:"";position:absolute;inset:0;border-radius:inherit;pointer-events:none;z-index:1;background:radial-gradient(ellipse at 28% 0%,#ffffff9c,transparent 48%),radial-gradient(ellipse at 78% 100%,#ffffff52,transparent 46%),linear-gradient(155deg,#ffffff28,transparent 38%,#dce3ed18 74%,#ffffff50);box-shadow:inset 0 3px 5px -3px #fff,inset 0 -4px 7px -5px #66748880}
#dacr-button .glass-rim{position:absolute;inset:0;width:100%;height:100%;overflow:visible;pointer-events:none;z-index:3}
#dacr-button #glass-refraction{position:absolute;inset:-40%;width:180%;height:180%;display:none;z-index:1}
#dacr-button.glass-canvas-ready #glass-refraction{display:block}
#dacr-button.glass-canvas-ready .dacr-button-visual{visibility:hidden}
#dacr-button .dacr-button-logo{position:relative;display:block;z-index:2;width:66.667%;height:66.667%}

</style></head><body>
<canvas id="living-glow"></canvas>
<div id="dacr-button"><canvas id="glass-refraction"></canvas><span class="dacr-button-visual"><svg class="dacr-button-logo" viewBox="0 0 26.075 26" fill="currentColor" focusable="false"><path d="M16.213 13.042c0 1.764-1.44 3.2-3.21 3.2a3.208 3.208 0 0 1-3.208-3.2c0-1.765 1.44-3.2 3.209-3.2h3.209v3.2Zm8.365-6.088H21.16A10.039 10.039 0 0 1 23.178 13c0 5.576-4.549 10.112-10.14 10.112-5.592 0-10.142-4.536-10.142-10.112 0-5.576 4.55-10.112 10.141-10.112 1.11 0 2.176.18 3.176.51v3.556h-3.21c-3.366 0-6.105 2.73-6.105 6.088 0 3.356 2.74 6.088 6.106 6.088 3.366 0 6.105-2.732 6.105-6.088V4.906l.002.001v-3.41A13.007 13.007 0 0 0 13.037 0C5.837 0 0 5.82 0 13s5.837 13 13.037 13c7.2 0 13.038-5.82 13.038-13 0-2.184-.543-4.24-1.497-6.046Z"/></svg></span></div>
<script>
window.addEventListener('error',()=>parent.postMessage('dacr-glow-error','*'));
window.prism={mode:'idle',effect:'glow',level:0,bass:0,treble:0,reduced:false};
(() => {
  'use strict';
  const state=window.prism;
  const button=document.querySelector('#dacr-button');
  let glowCanvas = document.querySelector('#living-glow');
  const gl = glowCanvas.getContext('webgl', {alpha:true, premultipliedAlpha:true, antialias:false, powerPreference:'low-power'});
  let fallback, program, uniforms;
  let age = 100, reveal = 0, phase = 2.1, previousLevel = 0, impact = 0, energy = 0;
  const vertex = 'attribute vec2 p; void main(){gl_Position=vec4(p,0.,1.);}';
  const rampStops = ['#20b8c4','#77bcee','#b0a4f5','#f16eae','#ff8f75','#ffc253'];
  function toLab(hex){
    const rgb=[1,3,5].map(i=>parseInt(hex.slice(i,i+2),16)/255).map(v=>v<=.04045?v/12.92:((v+.055)/1.055)**2.4);
    const [r,g,b]=rgb;
    const l=Math.cbrt(.4122214708*r+.5363325363*g+.0514459929*b),m=Math.cbrt(.2119034982*r+.6806995451*g+.1073969566*b),s=Math.cbrt(.0883024619*r+.2817188376*g+.6299787005*b);
    return [Math.max(.77,.2104542553*l+.7936177850*m-.0040720468*s),1.9779984951*l-2.4285922050*m+.4505937099*s,.0259040371*l+.7827717662*m-.8086757660*s];
  }
  function fromLab([L,a,b]){
    const l=(L+.3963377774*a+.2158037573*b)**3,m=(L-.1055613458*a-.0638541728*b)**3,s=(L-.0894841775*a-1.291485548*b)**3;
    return [4.0767416621*l-3.3077115913*m+.2309699292*s,-1.2684380046*l+2.6097574011*m-.3413193965*s,-.0041960863*l-.7034186147*m+1.707614701*s].map(v=>Math.round(Math.min(1,Math.max(0,v<=.0031308?v*12.92:1.055*Math.pow(v,1/2.4)-.055))*255));
  }
  const labs=rampStops.map(toLab),ramp=new Uint8Array(256*4);
  for(let i=0;i<256;i++){
    const lab=[0,0,0];let weight=0;
    labs.forEach((color,j)=>{const w=Math.exp(-(((i/255-j/(labs.length-1))/.155)**2));weight+=w;for(let k=0;k<3;k++)lab[k]+=color[k]*w;});
    ramp.set([...fromLab(lab.map(v=>v/weight)),255],i*4);
  }
  const fragment = \`precision highp float;
    uniform vec2 resolution, center;
    uniform float time, level, bass, treble, reveal, burst, radius, impact, intensity;
    uniform sampler2D colorRamp;
    float hash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}
    float noise(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*f*(f*(f*6.-15.)+10.);return mix(mix(hash(i),hash(i+vec2(1.,0.)),f.x),mix(hash(i+vec2(0.,1.)),hash(i+vec2(1.)),f.x),f.y);}
    void main(){
      if(reveal<.002){gl_FragColor=vec4(0.);return;}
      vec2 p=(gl_FragCoord.xy-center)/max(radius,1.);
      float expansion=.85+.43*reveal+burst*.42+bass*.14+impact*.07;
      p/=expansion;
      float t=time;
      vec2 warp=vec2(noise(p*.65+vec2(t*.18,-t*.14)),noise(p*.63+vec2(-t*.13,t*.17)))-.5;
      vec2 q=p+warp*(.42+level*.50+treble*.22);
      float field=.50+.29*sin(q.x*.88+sin(q.y*.74+t*.29)*.75+t*.28)
                       +.23*cos(q.y*.91-q.x*.28-t*.23)
                       +.055*sin(q.x*.42+q.y*.7+t*.47);
      vec3 color=texture2D(colorRamp,vec2(clamp(field,0.,1.),.5)).rgb;
      float mass=0.;
      for(int j=0;j<5;j++){
        float i=float(j),a=i*1.256637+t*(.17+.015*i)+sin(t*.41+i*1.7)*(.24+level*.34);
        float orbit=.60+.20*sin(t*.51+i*1.9)+level*.15;
        vec2 center=vec2(cos(a),sin(a))*orbit;
        center+=vec2(sin(t*.67+i*2.7),cos(t*.58+i*1.4))*(.12+level*.22+impact*.16);
        vec2 d=q-center;
        d/=vec2(.94+.14*sin(t*.36+i),.98+.14*cos(t*.43+i*1.4))+level*.12;
        mass+=exp(-dot(d,d)*1.45)*.68;
      }
      float opacity=(1.-exp(-mass*1.30))*reveal;
      opacity*=intensity;
      color+=(hash(gl_FragCoord.xy)-.5)*.0013;
      gl_FragColor=vec4(color*opacity,opacity);
    }\`;
  function shader(type, source){const s=gl.createShader(type);gl.shaderSource(s,source);gl.compileShader(s);if(!gl.getShaderParameter(s,gl.COMPILE_STATUS))throw Error(gl.getShaderInfoLog(s));return s;}
  try {
    if(!gl)throw Error('WebGL unavailable');
    program=gl.createProgram();gl.attachShader(program,shader(gl.VERTEX_SHADER,vertex));gl.attachShader(program,shader(gl.FRAGMENT_SHADER,fragment));gl.linkProgram(program);
    if(!gl.getProgramParameter(program,gl.LINK_STATUS))throw Error(gl.getProgramInfoLog(program));
    gl.useProgram(program);const buffer=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,buffer);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,1,-1,-1,1,-1,1,1,-1,1,1]),gl.STATIC_DRAW);
    const p=gl.getAttribLocation(program,'p');gl.enableVertexAttribArray(p);gl.vertexAttribPointer(p,2,gl.FLOAT,false,0,0);
    uniforms=Object.fromEntries(['resolution','center','time','level','bass','treble','reveal','burst','radius','impact','intensity'].map(n=>[n,gl.getUniformLocation(program,n)]));
    const texture=gl.createTexture();gl.activeTexture(gl.TEXTURE0);gl.bindTexture(gl.TEXTURE_2D,texture);
    gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
    gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,256,1,0,gl.RGBA,gl.UNSIGNED_BYTE,ramp);
    gl.uniform1i(gl.getUniformLocation(program,'colorRamp'),0);
  } catch {
    const replacement=glowCanvas.cloneNode();glowCanvas.replaceWith(replacement);glowCanvas=replacement;fallback=replacement.getContext('2d');
  }
  function resize(canvas){const dpr=Math.min(devicePixelRatio||1,.75);const w=Math.round(canvas.clientWidth*dpr),h=Math.round(canvas.clientHeight*dpr);if(canvas.width!==w||canvas.height!==h){canvas.width=w;canvas.height=h;}return dpr;}
  let fallbackField, fallbackPixels;
  function canvasGlow(ctx,t,kick,radius,intensity){
    const w=ctx.canvas.width,h=ctx.canvas.height;ctx.clearRect(0,0,w,h);
    if(reveal<.002)return;
    if(!fallbackField){fallbackField=document.createElement('canvas');fallbackField.width=fallbackField.height=128;fallbackPixels=fallbackField.getContext('2d').createImageData(128,128);}
    const data=fallbackPixels.data,expansion=.85+.43*reveal+kick*.42+state.bass*.14+impact*.07;
    const centers=Array.from({length:5},(_,i)=>{const a=i*1.256637+t*(.17+.015*i)+Math.sin(t*.41+i*1.7)*(.24+state.level*.34);const r=.6+.2*Math.sin(t*.51+i*1.9)+state.level*.15;return [Math.cos(a)*r,Math.sin(a)*r];});
    for(let y=0;y<128;y++)for(let x=0;x<128;x++){
      const px=(x/127*w-(state.anchorX??glowCanvas.clientWidth/2)*w/glowCanvas.clientWidth)/radius/expansion,py=((state.anchorY??glowCanvas.clientHeight/2)*h/glowCanvas.clientHeight-y/127*h)/radius/expansion;
      const qx=px+.12*Math.sin(py*.7+t*.21),qy=py+.12*Math.cos(px*.7-t*.18);
      const field=.50+.29*Math.sin(qx*.88+Math.sin(qy*.74+t*.29)*.75+t*.28)+.23*Math.cos(qy*.91-qx*.28-t*.23)+.055*Math.sin(qx*.42+qy*.7+t*.47);
      const idx=Math.round(Math.min(1,Math.max(0,field))*255)*4;
      let mass=0;for(const [cx,cy]of centers)mass+=Math.exp(-((qx-cx)**2+(qy-cy)**2)*1.45)*.68;
      const alpha=(1-Math.exp(-mass*1.3))*reveal*intensity,offset=(y*128+x)*4;
      for(let k=0;k<3;k++)data[offset+k]=ramp[idx+k];
      data[offset+3]=Math.round(alpha*255);
    }
    fallbackField.getContext('2d').putImageData(fallbackPixels,0,0);ctx.imageSmoothingEnabled=true;ctx.imageSmoothingQuality='high';ctx.drawImage(fallbackField,0,0,w,h);
  }
  window.paintDacr = (now,dt) => {
    age+=dt;
    const active=state.mode==='microphone'||state.mode==='requesting';
    reveal+=((active?1:0)-reveal)*(1-Math.exp(-dt*(active?22:24)));
    const onset=Math.min(1,Math.max(0,state.level-previousLevel)*12);previousLevel=state.level;
    impact+=(onset-impact)*(1-Math.exp(-dt*(onset>impact?30:4)));
    const target=active?1-Math.exp(-Math.max(0,state.level-.015)*4.5):0;
    energy+=(target-energy)*(1-Math.exp(-dt*(target>energy?24:8)));
    state.glowEnergy=energy;
    if(!state.reduced&&active)phase+=dt*(.32+energy*.55+state.treble*.20+impact*.15);
    const kick=state.reduced?0:Math.sin(Math.min(1,age/.38)*Math.PI)*Math.exp(-age*2);
    const intensity=Math.min(1,.18+energy*.98+kick*.52);
    if(state.effect==='glow'){
      const dpr=resize(glowCanvas),w=glowCanvas.width,h=glowCanvas.height;
      const radius=button.offsetWidth*.5*dpr;
      if(fallback){canvasGlow(fallback,phase,kick,radius,intensity);return;}
      gl.viewport(0,0,w,h);gl.uniform2f(uniforms.resolution,w,h);
      gl.uniform2f(uniforms.center,(state.anchorX??glowCanvas.clientWidth/2)*dpr,h-(state.anchorY??glowCanvas.clientHeight/2)*dpr);
      const values={time:phase,level:state.level,bass:state.bass,treble:state.treble,reveal,burst:kick,radius,impact,intensity};
      for(const [key,value] of Object.entries(values))gl.uniform1f(uniforms[key],value);
      gl.drawArrays(gl.TRIANGLES,0,6);
    }
  };

  state.triggerBurst=()=>{age=0;};
})();
(() => {
  'use strict';
  const state=window.prism;
  const button=document.querySelector('#dacr-button');
  const canvas=document.querySelector('#glass-refraction');
  const ctx=canvas.getContext('2d');
  const snapshot=document.createElement('canvas'),snapshotCtx=snapshot.getContext('2d');
  const glass=document.createElement('canvas'),glassCtx=glass.getContext('2d');
  const shadow=document.createElement('canvas'),shadowCtx=shadow.getContext('2d');
  if(!ctx||!snapshotCtx||!glassCtx||!shadowCtx||typeof Path2D==='undefined')return;
  const logo=new Path2D(button.querySelector('.dacr-button-logo path').getAttribute('d'));
  const reducedMotion={get matches(){return state.reduced;}};
  const TAU=Math.PI*2,EXTENT=1.8,GLASS_INTERVAL=1000/30;
  let source,lastEffect,geometry,ready=false,lastGlassFrame=-Infinity;
  let wasListening=false,pulseStart=0,stopStart=0,stopScale=1,currentScale=1;
  let rimReveal=0,rimTime=0,lastRimFrame;
  const rimColors=[[27,190,219],[123,195,237],[185,165,238],[219,49,153],
    [248,70,0],[255,162,11],[255,210,115],[165,223,200],[27,190,219]];
  const invalidate=()=>{geometry=null;lastGlassFrame=-Infinity;};
  state.invalidateGlass= invalidate;
  const resizeObserver=new ResizeObserver(invalidate);
  resizeObserver.observe(button);
  window.addEventListener('resize',invalidate);

  function measure(){
    const bounds=button.getBoundingClientRect();
    if(!bounds.width)return null;
    const dpr=Math.min(3,Math.max(2,devicePixelRatio||1));
    const backdrop=source?.getBoundingClientRect();
    const canCopy=!!(backdrop?.width&&backdrop?.height&&source.width&&source.height);
    const sx=canCopy?source.width/backdrop.width:0,sy=canCopy?source.height/backdrop.height:0;
    return {
      width:bounds.width,dpr,pixels:Math.ceil(bounds.width*EXTENT*dpr),
      glassPixels:Math.ceil(bounds.width*Math.min(dpr,1.5)),canCopy,
      cx:canCopy?(bounds.left+bounds.width/2-backdrop.left)*sx:0,
      cy:canCopy?(bounds.top+bounds.height/2-backdrop.top)*sy:0,
      sw:bounds.width*sx,sh:bounds.height*sy,
      sourceWidth:source?.width,sourceHeight:source?.height
    };
  }

  function updateGlass(now,g){
    if(now-lastGlassFrame<GLASS_INTERVAL)return;
    lastGlassFrame=now;
    const {glassPixels:size,width,cx,cy,sw,sh}=g;
    if(glass.width!==size){glass.width=glass.height=size;snapshot.width=snapshot.height=size;}
    glassCtx.clearRect(0,0,size,size);
    if(!g.canCopy)return;
    snapshotCtx.clearRect(0,0,size,size);
    snapshotCtx.imageSmoothingEnabled=true;snapshotCtx.imageSmoothingQuality='high';
    if('filter' in snapshotCtx)snapshotCtx.filter=\`blur(\${size/width*.65}px) saturate(1.18)\`;
    try{
      snapshotCtx.drawImage(source,cx-sw/2,cy-sh/2,sw,sh,0,0,size,size);
    }catch{
      return;
    }
    const half=size/2,slices=14;
    glassCtx.imageSmoothingEnabled=true;glassCtx.imageSmoothingQuality='high';
    for(let i=0;i<slices;i++){
      const inner=i/slices,outer=(i+1)/slices,edge=Math.max(0,(outer-.64)/.36);
      const crop=size/(1.045+Math.pow(edge,2.3)*.28),inset=(size-crop)/2;
      glassCtx.save();glassCtx.beginPath();glassCtx.arc(half,half,half*outer,0,TAU);glassCtx.closePath();
      if(i>0){
        const innerRadius=Math.max(0,half*inner-.45);
        glassCtx.moveTo(half+innerRadius,half);glassCtx.arc(half,half,innerRadius,0,TAU,true);glassCtx.closePath();
      }
      glassCtx.clip('evenodd');
      glassCtx.drawImage(snapshot,inset,inset,crop,crop,0,0,size,size);
      glassCtx.restore();
    }
  }

  function pulse(now){
    const listening=state.mode==='microphone';
    if(listening&&!wasListening)pulseStart=now;
    if(!listening&&wasListening){stopStart=now;stopScale=currentScale;}
    wasListening=listening;
    if(reducedMotion.matches)return currentScale=1;
    if(listening)return currentScale=1+.014*(1-Math.cos((now-pulseStart)/2800*TAU));
    const t=Math.min(1,(now-stopStart)/140),ease=t*t*(3-2*t);
    return currentScale=1+(stopScale-1)*(1-ease);
  }

  function circle(radius){ctx.beginPath();ctx.arc(0,0,radius,0,TAU);}
  function drawListeningRim(now,radius){
    const dt=lastRimFrame===undefined?0:Math.max(0,Math.min(.05,(now-lastRimFrame)/1000));
    lastRimFrame=now;
    const active=state.mode==='microphone'||state.mode==='requesting';
    rimReveal+=((active?1:0)-rimReveal)*(1-Math.exp(-dt*(active?22:24)));
    if(!reducedMotion.matches&&active)rimTime+=dt;
    if(rimReveal<.002)return;
    const start=-Math.PI*.88+rimTime*TAU/24,span=TAU*.39;
    const gradient=ctx.createConicGradient(start,0,0);
    const flow=rimTime/36;
    for(let i=0;i<=48;i++){
      const u=i/48,v=((u*.76+flow)%1)*(rimColors.length-1),index=Math.floor(v);
      const f=v-index,color=rimColors[index].map((value,k)=>Math.round(value+(rimColors[index+1][k]-value)*f));
      const edge=Math.min(1,u/.18,(1-u)/.18),fade=edge*edge*(3-2*edge);
      gradient.addColorStop(u*.39,\`rgba(\${color.join(',')},\${fade})\`);
    }
    gradient.addColorStop(1,'rgba(27,190,219,0)');
    ctx.save();ctx.strokeStyle=gradient;ctx.lineCap='butt';
    const strength=rimReveal*(.74+.20*(state.glowEnergy||0));
    for(const [width,opacity] of [[12,.014],[8,.028],[4,.075],[.95,.94]]){
      ctx.lineWidth=width;ctx.globalAlpha=strength*opacity;
      ctx.beginPath();ctx.arc(0,0,radius-.55,start,start+span);ctx.stroke();
    }
    ctx.restore();
  }
  function cacheShadow(g){
    const {pixels,width}=g,ratio=pixels/(width*EXTENT);
    shadow.width=shadow.height=pixels;
    shadowCtx.setTransform(ratio,0,0,ratio,pixels/2,pixels/2);
    shadowCtx.shadowColor='rgba(0,0,0,.1)';shadowCtx.shadowBlur=26*ratio;shadowCtx.shadowOffsetY=8*ratio;
    shadowCtx.beginPath();shadowCtx.arc(0,0,width/2,0,TAU);shadowCtx.fillStyle='#fff';shadowCtx.fill();
    shadowCtx.shadowColor='transparent';shadowCtx.globalCompositeOperation='destination-out';shadowCtx.fill();
  }
  function drawButton(scale,g,now){
    const {pixels,width}=g,ratio=pixels/(width*EXTENT),radius=width/2;
    if(canvas.width!==pixels||canvas.height!==pixels){canvas.width=canvas.height=pixels;}
    ctx.setTransform(1,0,0,1,0,0);ctx.clearRect(0,0,pixels,pixels);
    ctx.setTransform(ratio*scale,0,0,ratio*scale,pixels/2,pixels/2);
    ctx.imageSmoothingEnabled=true;ctx.imageSmoothingQuality='high';
    const face=ctx.createLinearGradient(-radius,-radius,radius,radius);
    face.addColorStop(0,'rgba(255,255,255,.84)');
    face.addColorStop(.48,'rgba(255,255,255,.68)');
    face.addColorStop(1,'rgba(255,255,255,.76)');
    ctx.drawImage(shadow,-width*EXTENT/2,-width*EXTENT/2,width*EXTENT,width*EXTENT);
    circle(radius);ctx.fillStyle=face;ctx.fill();
    ctx.save();circle(radius);ctx.clip();
    ctx.globalAlpha=.32;ctx.drawImage(glass,-radius,-radius,width,width);ctx.globalAlpha=1;
    const sheen=ctx.createRadialGradient(-radius*.45,-radius*.95,0,-radius*.45,-radius*.95,width*.78);
    sheen.addColorStop(0,'rgba(255,255,255,.56)');sheen.addColorStop(1,'rgba(255,255,255,0)');
    ctx.fillStyle=sheen;ctx.fillRect(-radius,-radius,width,width);
    const reflection=ctx.createRadialGradient(radius*.5,radius,0,radius*.5,radius,width*.56);
    reflection.addColorStop(0,'rgba(255,255,255,.3)');reflection.addColorStop(1,'rgba(255,255,255,0)');
    ctx.fillStyle=reflection;ctx.fillRect(-radius,-radius,width,width);
    ctx.restore();
    const rim=ctx.createLinearGradient(-radius*.8,-radius,radius*.8,radius);
    for(const [stop,color] of [[0,'#fff'],[.28,'rgba(255,255,255,.9)'],[.49,'rgba(255,255,255,.24)'],[.72,'rgba(255,255,255,.92)'],[1,'rgba(255,255,255,.5)']])rim.addColorStop(stop,color);
    circle(radius-.6);ctx.strokeStyle=rim;ctx.lineWidth=1.2;ctx.stroke();
    drawListeningRim(now,radius);
    ctx.save();
    const logoWidth=width*2/3,logoScale=logoWidth/26.075;
    ctx.translate(-logoWidth/2,-26*logoScale/2);ctx.scale(logoScale,logoScale);
    ctx.fillStyle='#2a2b2c';ctx.fill(logo);ctx.restore();
    if(!ready){button.classList.add('glass-canvas-ready');ready=true;}
  }

  window.paintDacrGlass=(now=performance.now())=>{
    if(state.effect!==lastEffect){
      if(source)resizeObserver.unobserve(source);
      lastEffect=state.effect;
      source=document.querySelector(state.effect==='glow'?'#living-glow':state.effect==='prism'?'#visualizer':'#concepts');
      if(source)resizeObserver.observe(source);
      invalidate();
    }
    const dpr=Math.min(3,Math.max(2,devicePixelRatio||1));
    if(!geometry||geometry.sourceWidth!==source?.width||geometry.sourceHeight!==source?.height||geometry.dpr!==dpr){
      geometry=measure();lastGlassFrame=-Infinity;
      if(geometry)cacheShadow(geometry);
    }
    if(!geometry)return;
    updateGlass(now,geometry);
    drawButton(pulse(now)*(state.pressScale??1),geometry,now);
  };
})();

(() => {
  'use strict';
  const state=window.prism;
  const button=document.querySelector('#dacr-button');
  const bands=new Uint8Array(128);
  state.bands=bands;state.sensitivity=1.5;
  const clamp=n=>Math.min(1,Math.max(0,n));
  const FFT=2048,HALF=FFT/2,SMOOTHING=.68,MIN_DB=-90,MAX_DB=-20;
  const RING=1<<16,MASK=RING-1,ring=new Float32Array(RING);
  const STALE=250;
  const waveform=new Float32Array(FFT),frequency=new Uint8Array(HALF),smoothed=new Float64Array(HALF);
  const re=new Float64Array(FFT),im=new Float64Array(FFT),blackman=new Float64Array(FFT);
  const reverse=new Uint16Array(FFT),cos=new Float64Array(HALF),sin=new Float64Array(HALF);
  for(let n=0;n<FFT;n++){
    blackman[n]=.42-.5*Math.cos(2*Math.PI*n/FFT)+.08*Math.cos(4*Math.PI*n/FFT);
    let r=0;for(let b=1,v=n;b<FFT;b<<=1,v>>=1)r=(r<<1)|(v&1);reverse[n]=r;
  }
  for(let k=0;k<HALF;k++){cos[k]=Math.cos(-2*Math.PI*k/FFT);sin[k]=Math.sin(-2*Math.PI*k/FFT);}
  function fft(){
    for(let i=0;i<FFT;i++){const j=reverse[i];if(j>i){let t=re[i];re[i]=re[j];re[j]=t;t=im[i];im[i]=im[j];im[j]=t;}}
    for(let size=2;size<=FFT;size<<=1){
      const half=size>>1,step=FFT/size;
      for(let start=0;start<FFT;start+=size)for(let k=0;k<half;k++){
        const a=start+k,b=a+half,c=cos[k*step],s=sin[k*step];
        const tr=re[b]*c-im[b]*s,ti=re[b]*s+im[b]*c;
        re[b]=re[a]-tr;im[b]=im[a]-ti;re[a]+=tr;im[a]+=ti;
      }
    }
  }
  let sampleRate=0,ranges=null,written=0,analysed=-1,receivedAt=-Infinity;
  function resetAnalyser(){ring.fill(0);smoothed.fill(0);frequency.fill(0);written=0;analysed=-1;receivedAt=-Infinity;}
  function analyse(){
    const end=written;
    if(end===analysed)return;
    for(let i=0;i<FFT;i++){const at=end-FFT+i;waveform[i]=at<0?0:ring[at&MASK];}
    const smoothing=analysed<0?SMOOTHING:Math.pow(SMOOTHING,(end-analysed)/sampleRate*60);
    analysed=end;
    for(let i=0;i<FFT;i++){re[i]=waveform[i]*blackman[i];im[i]=0;}
    fft();
    const scale=255/(MAX_DB-MIN_DB);
    for(let k=0;k<HALF;k++){
      const magnitude=Math.hypot(re[k],k?im[k]:0)/FFT;
      smoothed[k]=smoothing*smoothed[k]+(1-smoothing)*magnitude;
      const db=smoothed[k]?20*Math.log10(smoothed[k]):-1000;
      frequency[k]=Math.min(255,Math.max(0,Math.floor((db-MIN_DB)*scale)));
    }
  }
  function setRate(rate){
    if(rate===sampleRate)return;
    sampleRate=rate;
    ranges=Array.from({length:128},(_,i)=>{
      const low=55*Math.pow(14000/55,i/128);
      const high=55*Math.pow(14000/55,(i+1)/128);
      const bin=sampleRate/FFT;
      const start=Math.max(1,Math.min(frequency.length-1,Math.floor(low/bin)));
      return [start,Math.min(frequency.length,Math.max(start+1,Math.ceil(high/bin)))];
    });
  }
  function sample(dt){
    if(state.mode!=='microphone')return;
    if(!ranges||performance.now()-receivedAt>STALE){
      const decay=Math.exp(-dt*6);
      state.level*=decay;state.bass*=decay;state.treble*=decay;
      for(let i=0;i<bands.length;i++)bands[i]*=decay;
      return;
    }
    analyse();
    let energy=0;
    for(let i=0;i<waveform.length;i++)energy+=waveform[i]*waveform[i];
    const rms=Math.sqrt(energy/waveform.length);
    const volume=clamp(Math.sqrt(Math.max(0,rms-.0015)*state.sensitivity*3.2));
    const smoothing=1-Math.exp(-dt*(volume>state.level?24:6));
    state.level+=(volume-state.level)*smoothing;
    let low=0,high=0;
    for(let i=0;i<128;i++){
      const [from,to]=ranges[i];
      let sum=0;for(let j=from;j<to;j++)sum+=frequency[j];
      const value=clamp(sum/(to-from)/255*Math.sqrt(state.sensitivity)*Math.min(1,volume*5));
      bands[i]+=(value*255-bands[i])*(1-Math.exp(-dt*16));
      if(i<35)low+=value/35;
      if(i>=80)high+=value/48;
    }
    state.bass+=(low*volume-state.bass)*smoothing;
    state.treble+=(high-state.treble)*smoothing;
  }
  const SETTLE=450;
  let pressed=false,pressVelocity=0;
  state.pressScale=1;
  function pressStep(dt){
    const target=pressed ? .92 : 1;
    if(state.reduced){state.pressScale=1;pressVelocity=0;return false;}
    for(let remaining=dt;remaining>0;){
      const step=Math.min(remaining,1/120);remaining-=step;
      pressVelocity+=((target-state.pressScale)*650-pressVelocity*32)*step;
      state.pressScale+=pressVelocity*step;
    }
    if(Math.abs(target-state.pressScale)<.0002&&Math.abs(pressVelocity)<.004){state.pressScale=target;pressVelocity=0;return false;}
    return true;
  }
  window.setDacrPressed=value=>{pressed=!!value;wake();};
  let frameId=0,last=0,settleUntil=0,anchored=false,announced=false;
  function wake(){if(!frameId)frameId=requestAnimationFrame(frame);}
  function frame(now){
    frameId=0;
    if(document.hidden){last=0;return;}
    const dt=Math.min((now-last)/1000||.016,.05);last=now;
    if(state.mode==='idle'){state.level*=.90;state.bass*=.90;state.treble*=.90;for(let i=0;i<bands.length;i++)bands[i]*=.90;}
    sample(dt);
    const pressing=pressStep(dt);
    if(state.mode!=='idle'||now<settleUntil||!announced)window.paintDacr(now,dt);
    window.paintDacrGlass(now);
    if(anchored&&!announced){announced=true;parent.postMessage('dacr-glow-ready','*');}
    if(state.mode!=='idle'||now<settleUntil||!announced||pressing)wake();
    else last=0;
  }
  window.setDacrListening=(mode,reduced)=>{
    const next=mode==='requesting'||mode==='microphone'?mode:'idle';
    const previous=state.mode;
    if(next!==previous){
      if(previous==='idle'){state.level=state.bass=state.treble=0;bands.fill(0);state.triggerBurst();}
      if(next==='microphone')resetAnalyser();
      state.mode=next;
      if(next==='idle'){settleUntil=performance.now()+SETTLE;state.level=state.bass=state.treble=0;bands.fill(0);}
    }
    state.reduced=!!reduced;
    wake();
  };
  window.pushDacrPcm=(encoded,rate)=>{
    if(state.mode!=='microphone'||!(rate>0))return;
    setRate(rate);
    const binary=atob(encoded),count=binary.length>>1;
    for(let i=0;i<count;i++){
      let value=binary.charCodeAt(i*2)|(binary.charCodeAt(i*2+1)<<8);
      if(value&0x8000)value-=0x10000;
      ring[(written+i)&MASK]=value/32768;
    }
    written+=count;receivedAt=performance.now();
  };
  window.setDacrAnchor=(x,y)=>{
    if(!Number.isFinite(x)||!Number.isFinite(y))return;
    button.style.left=x+'px';button.style.top=y+'px';
    state.anchorX=x;state.anchorY=y;
    state.invalidateGlass?.();
    anchored=true;wake();
  };
  document.addEventListener('visibilitychange',()=>{
    if(document.hidden){cancelAnimationFrame(frameId);frameId=0;last=0;}
    else wake();
  });
  window.addEventListener('pagehide',()=>cancelAnimationFrame(frameId));
  window.addEventListener('resize',wake);
  wake();
})();
</script></body></html>`
